import { useTypedSelector } from "hooks";
import { RoleName } from "consts/auth";
import { concat, when } from "util/support";
import { selectAuthUser } from "features/auth/selectors";

export const useUser = () => {
    const user = useTypedSelector(selectAuthUser);

    const getUserName = (fallback = '') => when(
        user,
        () => concat([
            user.firstName,
            user.lastName
        ].filter(Boolean), { token: ' ' }) || fallback
    );

    const getRoleName = () => user?.roleName;

    const hasRole = (roles: Array<RoleName>) =>
        roles.includes(getRoleName());

    const getStatus = () => user?.status;

    return {
        user,
        hasRole,
        getUserName,
        getStatus,
        getRoleName
    };
};

export default useUser;
